var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.desc),function(d,index){return _c('div',{key:index},[_c('v-flex',{attrs:{"xs12":"","pb-1":""}},[_vm._v(_vm._s(d.description_en))]),(d.subdesc.lenght > 0)?_c('InvoiceItem',{attrs:{"desc":d.subdesc}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }